import { render, staticRenderFns } from "./InsightAreaChart.vue?vue&type=template&id=00b5a349&scoped=true&"
import script from "./InsightAreaChart.vue?vue&type=script&lang=js&"
export * from "./InsightAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./InsightAreaChart.vue?vue&type=style&index=0&id=00b5a349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b5a349",
  null
  
)

export default component.exports